import React from "react";
import CommonDetails from "./CommonDetails";
import { useParams } from "react-router-dom";
import { useGetSubmittedAgreementDetailsQuery } from "../../../../redux/api/submittedCopyrightAgreementApiSlice";
import Loader from "../../../../components/custom/Loader";
import {
  AgreementGenerateAttachments,
  AgreementGenerateAttachmentsValue,
} from "../../../../utils/agreementGenerateAttachArray";
import AgreementPreviewFormOne from "../../../../components/preview_applications/agreement/AgreementPreviewFormOne";
import AgreementPreviewFormTwo from "../../../../components/preview_applications/agreement/AgreementPreviewFormTwo";
import InspectorCommonContent from "../../../../components/common-content/InspectorCommonContent";
import { useAuth } from "../../../../utils/authorization";
import { transformAgreementData } from "../../../../utils/transformAgreementData";
import PaymentPreview from "../../../../components/preview_applications/payment/PaymentPreview";

const AgreementDetailsSubmitted = () => {
  const { authUser } = useAuth();
  const { id } = useParams();
  const { data, isLoading } = useGetSubmittedAgreementDetailsQuery(id, {
    refetchOnMountOrArgChange: true,
  });
  const documents = data?.data;

  if (isLoading) {
    return <Loader />;
  }

  const forInfo = transformAgreementData(documents);

  const infoTable = AgreementGenerateAttachments(forInfo);

  const infoModal = AgreementGenerateAttachmentsValue(forInfo);

  const info = {
    noteNumber: data?.data?.trackReg,
    regNumber: "",
    applicantName: data?.data?.applicantName,
    workTitle: data?.data?.documents?.worktitle,
    category: data?.data?.documents?.category?.name,
    amount: data?.data?.amount,
    challan: Number(data?.data?.st) === 3 ? "চালান" : "ট্রেজারি",
    challanNumber:
      Number(data?.data?.st) === 3
        ? data?.data?.echallanId
        : data?.data?.treasuryNo,
    treasuryDate: data?.data?.treasuryDate || new Date(),
    admin: data?.data?.admin,
  };

  const formOne = (
    <div className="p-4 mt-5">
      <AgreementPreviewFormOne data={data?.data} />
    </div>
  );
  const formTwo = (
    <div className="pt-5">
      <AgreementPreviewFormTwo data={data?.data} />
    </div>
  );
  const comments =
    data?.data?.comments.find((c) => Number(c.submit) === 2) ||
    (data?.data?.comments.length > 0 && data?.data?.comments[0]);

  const noteSheetList =
    data?.data?.comments.filter((c) => Number(c.submit) === 1) ?? [];

  const commentsValue = data?.data?.comments.find(
    (c) => Number(c.submit) === 2
  );
  
  const content = (
    <InspectorCommonContent
      comments={commentsValue}
      info={info}
      infoTable={infoTable}
      infoModal={infoModal}
    />
  );
  const commentsNoteSheet = {
    noteSheetList,
    noteSheetValues: comments?.status,
  };

  return (
    <div>
      <CommonDetails
        content={content}
        commentsNoteSheet={commentsNoteSheet}
        formOne={formOne}
        formTwo={formTwo}
        payment={
          <div className="p-4 mt-5">
            <PaymentPreview data={data?.data} />
          </div>
        }
        info={info}
        infoTable={infoTable}
        breadcrumbsTitle={"সাম্প্রতিক নথি"}
      />
    </div>
  );
};

export default AgreementDetailsSubmitted;
